/**
 * @author MrZenW
 * @email MrZenW@Gmail.com, https://MrZenW.com
 * @create date 2021-05-25 13:11:37
 * @modify date 2021-08-20 11:07:12
 * @desc [description]
 */

exports.SessionContext = require('react').createContext({});
